<aside
    aria-label="Filter"
    class="filter-container"
    pFocusTrap
    id="filters"
    [pFocusTrapDisabled]="!isMobile || !showOtherFilters"
    [class.filter-container--expanded]="showOtherFilters"
>
    <!-- Only displayed on desktop -->
    <h2 class="filter-container__title">
        Suche
    </h2>
    <!-- Elements in this component change visibility and position depending on mobile/desktop and whether advanced search is active -->
    <div
        class="filter-container__search-bar"
        [class.filter-container__search-bar--minimal]="!isMobile || !showOtherFilters"
        [class.filter-container__search-bar--expanded]="showOtherFilters"
    >
        <!-- Only displayed on mobile if advanced search is active -->
        @if (showOtherFilters) {
            <h2
                class="filter-container__search-bar-mobile-expanded-title"
            >
                Erweiterte Suche
            </h2>
        }

        <ng-template #ShowFilters>
            <!-- Only displayed on mobile -->
            <button
                #ShowFiltersButton
                class="filter-container__show-filters-button"
                aria-controls="filters"
                [class.filter-container__show-filters-button--expanded]="showOtherFilters"
                [attr.aria-label]="showOtherFilters ? 'Filter ausblenden' : 'Weitere Filter anzeigen'"
                [attr.aria-expanded]="showOtherFilters"
                (click)="showOtherFilters = !showOtherFilters"
                (keydown.escape)="showOtherFilters = false"
            >
                <ui-icon
                    aria-hidden
                    class="filter-container__show-filters-button-icon"
                    [icon]="showOtherFilters ? 'close-large' : 'filters-show'"
                />
            </button>
        </ng-template>

        <ng-template #SearchFilter>
            <!-- Always displayed, but changes position on mobile if advanced search is active -->
            <div
                class="filter-container__search-filter"
                [class.filter-container__search-filter--expanded]="showOtherFilters"
            >
                <ng-content select="[search-filter]"/>
            </div>
        </ng-template>

        <!-- Since the position changes depending on the filters button, this changes the tab order as well -->
        @switch (showOtherFilters) {
            @case (true) {
                <ng-container *ngTemplateOutlet="ShowFilters"/>
                <ng-container *ngTemplateOutlet="SearchFilter"/>
            }
            @case (false) {
                <ng-container *ngTemplateOutlet="SearchFilter"/>
                <ng-container *ngTemplateOutlet="ShowFilters"/>
            }
        }
    </div>

    <!-- Only displayed on mobile if advanced search is active, and always on desktop -->
    <div
        class="filter-container__other-filters"
        [class.hidden-on-mobile]="!showOtherFilters"
    >
        <div
            #FilterScrollShadows
            class="filter-container__other-filters-scroll-shadows"
        >
            <div
                #FilterScrollContent
                class="filter-container__other-filters-content"
                (scroll)="onScrollFilter()"
            >
                <ng-content/>
            </div>
        </div>

        <div class="filter-container__other-filters-close-button-container">
            <button
                class="filter-container__other-filters-close-button"
                pButton
                (click)="showOtherFilters = false"
            >
                Ergebnisse anzeigen
            </button>
        </div>
    </div>

    <!-- Only displayed if any filters are set, and hidden on mobile only if advanced search is not active -->
    <ui-reset-filter-container
        class="reset-filter-container"
        [class.hidden-on-mobile]="showOtherFilters"
    />
</aside>
